module.exports = __webpack_public_path__ + "img/Step-5.734a2a62.png";